
export default function Hero() {
  return (
    <section className="relative min-h-[80vh] md:min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <div className="w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/0c13e3335f2b68982ce2253750f395bc.jpg"
            alt="Auto Parts Workshop"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 md:px-8 max-w-[1400px] mx-auto w-full">
        <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-4 md:mb-8 leading-none" style={{ fontFamily: "'Anton', sans-serif" }}>
          자동차
          <br />
          교환부품 전문
        </h1>

        <p className="text-white/90 text-sm sm:text-base md:text-xl lg:text-2xl mb-8 md:mb-12 max-w-[800px] mx-auto leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
          라이트 · 범퍼 · 머드가드 등 차량 교환부품을 안정적인 품질로 공급합니다
        </p>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-6 justify-center items-center">
          <a
            href="/shop"
            className="bg-[#E63946] text-white px-8 md:px-12 py-3.5 md:py-5 text-sm md:text-lg font-bold hover:bg-[#D62839] transition-all duration-300 cursor-pointer whitespace-nowrap rounded-md"
            style={{ fontFamily: "'Anton', sans-serif" }}
          >
            제품 둘러보기
          </a>
          <a
            href="/contact"
            className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 md:px-12 py-3.5 md:py-5 text-sm md:text-lg font-bold hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap rounded-md"
            style={{ fontFamily: "'Anton', sans-serif" }}
          >
            문의하기
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 md:bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl md:text-3xl"></i>
      </div>
    </section>
  );
}
